import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiServices} from '../../shared/services/api.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-process-order',
  templateUrl: './process-order.component.html',
  styleUrls: ['./process-order.component.scss']
})
export class ProcessOrderComponent implements OnInit {

  queryParams: any;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiServices,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
      this.processOrder();
    });
  }

  ngOnInit(): void {
  }

  processOrder(): void {

    this.apiService.processOrder(this.queryParams).subscribe(
      response => {
        console.log('response', response);
        this.toastr.success(response.message, 'Success');
      }, err => {
        this.toastr.error(err.error.message, 'Error');
      }
    );
  }
}
